const version = require('../package.json').version;
module.exports = version;
